import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import XSifterQueryService from "../../services/XSifterQueryService";

interface IDeleteQueryConfirmationProps {
    queryId: string | null;
    onDialogClosed: () => void;
    onDeleteQuery: (queryId: string) => void;
}

const DeleteQueryConfirmation: React.FC<IDeleteQueryConfirmationProps> = (props: IDeleteQueryConfirmationProps) => {
    const queryService = new XSifterQueryService();
    const [thisQueryId, setThisQueryId] = useState<string | null>(null);
    const [queryTitle, setQueryTitle] = useState<string | null>(null);

    useEffect(() => {
        setThisQueryId(props.queryId);
        if (props.queryId) {
            queryService.getSavedQuery(props.queryId)
                .then((response) => {
                    setQueryTitle(response?.title ?? null);
                })
        }
    }, [props.queryId]);

    const onCloseQueryDelete = () => {
        setThisQueryId(null);
    }

    return (
        <Dialog open={thisQueryId !== null}
            onClose={onCloseQueryDelete} 
            role="alertdialog"
            aria-labelledby="id-confirm-dialog-title"
            aria-describedby="id-confirm-dialog-body"
        >
            <DialogTitle id="id-confirm-dialog-title">Delete saved query?</DialogTitle>
            <DialogContent>
                <DialogContentText id="id-confirm-dialog-body">
                    <div>
                        Are you sure you want to delete the query <strong>{queryTitle}</strong>?
                    </div>
                    <Divider style={{ marginTop: "8px", marginBottom: "8px"}} />
                    <div>
                        Any already downloaded Tweets will still remain in your DiscoverText account,
                        but you will not be able to re-use or modify this query.
                        This will also cancel any running jobs for this query.
                        This cannot be undone. 
                    </div>
                </DialogContentText>
                <DialogActions>
                    <Button onClick={onCloseQueryDelete}>
                        No, do not delete
                    </Button>
                    <Button onClick={() => props.onDeleteQuery(props.queryId ?? "")}>
                        Yes, delete this query
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default DeleteQueryConfirmation;

